import { render, staticRenderFns } from "./confirmationCard.vue?vue&type=template&id=c5958766&scoped=true&"
import script from "./confirmationCard.vue?vue&type=script&lang=js&"
export * from "./confirmationCard.vue?vue&type=script&lang=js&"
import style0 from "./confirmationCard.vue?vue&type=style&index=0&id=c5958766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5958766",
  null
  
)

export default component.exports